import { Dispute, PaymentRequest } from '../gql-types.generated';
import { Box, DialogActions, createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import DisputeInformation from './DisputeInformation';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    outerBox: {
      paddingBottom: theme.spacing(4),
    },
    closeBox: {
      padding: theme.spacing(1, 1, 0),
      marginBottom: '-8px',
    },
    closeButton: {
      padding: 0,
    },
    closeIcon: {
      fontSize: '28px',
      color: '#00000099',
    },
  }),
);

interface DisputeDetailsProps {
  disputedRecord: Dispute;
  relatedPayment: PaymentRequest | null | undefined;
  close: () => void;
}

const DisputeDetails: React.FC<DisputeDetailsProps> = props => {
  const classes = useStyles();
  const { disputedRecord, relatedPayment, close } = props;
  let disputeState = null;
  switch (disputedRecord.status) {
    case 'CONCEDED_AWAITING_PAYFAC': {
      disputeState = 'CONCEDED';
      break;
    }
    case 'CHALLENGE_AWAITING_PAYFAC': {
      disputeState = 'CHALLENGED';
      break;
    }
    case 'AWAITING_MERCHANT_RESPONSE': {
      disputeState = 'DISPUTED';
      break;
    }
    case 'PENDING_PAYFAC_REVIEW': {
      disputeState = 'CHALLENGED';
      break;
    }
    case 'AWAITING_CHARGEBACK_DECISION': {
      disputeState = 'CHALLENGED';
      break;
    }
    case 'RESOLVED': {
      if (disputedRecord.concedeMessage && disputedRecord.concedeMessage !== '') {
        disputeState = 'CONCEDED';
        break;
      }
      disputeState = 'CHALLENGED';
      break;
    }
    default: {
      disputeState = 'UNKNOWN';
    }
  }

  return (
    <Box className={classes.outerBox}>
      <DialogActions className={classes.closeBox}>
        <IconButton className={classes.closeButton} onClick={() => close()} data-cy="close-dispute">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogActions>
      <DisputeInformation disputedRecord={disputedRecord} disputeState={disputeState} relatedPayment={relatedPayment} />
    </Box>
  );
};

export default DisputeDetails;
